import { Controller } from "@hotwired/stimulus"

// IMPORTANT: use jquery notation for listeners for correct interaction with related js methods!

export default class extends Controller {
    connect() {
        // Bind listeners only to children of this.element
        this.bindStopOnly(".freigabe-current")
        this.bindStopOnly(".freigabe-disabled")
        this.bind(".freigabe-new", freigabe_new_markieren)
    }

    disconnect() {
        // Remove listeners when element is removed by Turbo
        this.element.querySelectorAll(".freigabe-current").forEach(el => {
            $(el).off("click.freigabeCheckboxSet")
        })
        this.element.querySelectorAll(".freigabe-disabled").forEach(el => {
            $(el).off("click.freigabeCheckboxSet")
        })
        this.element.querySelectorAll(".freigabe-new").forEach(el => {
            $(el).off("click.freigabeCheckboxSet")
        })
    }

    bind(selector, fn) {
        this.element.querySelectorAll(selector).forEach(el => {
            $(el).off("click.freigabeCheckboxSet")  // remove previous listener
            $(el).on("click.freigabeCheckboxSet", function(e) {
                e.stopPropagation()
                fn(e)
            })
        })
    }

    bindStopOnly(selector) {
        this.element.querySelectorAll(selector).forEach(el => {
            $(el).off("click.freigabeCheckboxSet")  // remove previous listener
            $(el).on("click.freigabeCheckboxSet", function(e) {
                e.stopPropagation()
            })
        })
    }
}
